import classNames from "classnames";
import React, { Fragment, useRef, useState } from "react";
import Barcoder from "src/utils/barcoder";
import { BarcodeFormatter } from "src/utils/formatters";
import AbortablePromise from "src/utils/promise/AbortablePromise";
import { postData } from "src/utils/request";

const validator = new Barcoder('ean13', undefined);

export default () => {
    const [response, setResponse] = useState(null);
    const request = useRef<AbortablePromise<any> | null>(null);
    const inputRef = useRef<HTMLInputElement | null>(null);
    return (
        <Fragment>
            <input
                ref={inputRef}
                className={classNames(
                    "p-inputtext p-component form-control"
                )}
                defaultValue=""
                onChange={(e) => {
                    inputRef.current.classList.remove("is-invalid");
                    request.current?.abort();
                    let barcode = e.target.value.trim();
                    if (barcode === '') return;
                    barcode = `${BarcodeFormatter(barcode || '')}`;
                    if (barcode.length === 12) {
                        barcode = `0${barcode}`;
                    }
                    if (barcode.length === 13 && validator.validate(barcode)) {
                        /*request.current = postData({
                            action: "BooklogStoreOrder.valami",
                            params: {
                                barcode
                            }
                        });
                        request.current.then((r) => {
                            setResponse(r);
                        });*/
                        return;
                    }
                    inputRef.current.classList.add("is-invalid");
                }}
            />
            <code>{JSON.stringify(response, null, 2)}</code>
        </Fragment>
    )
}